import { render, staticRenderFns } from "./privilegeAdd.vue?vue&type=template&id=55502503&"
import script from "./privilegeAdd.vue?vue&type=script&lang=js&"
export * from "./privilegeAdd.vue?vue&type=script&lang=js&"
import style0 from "./privilegeAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports